import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { getFirestore, deleteDoc, updateDoc, arrayUnion, setDoc, collection, getDocs, query, where, doc, getDoc, addDoc } from 'firebase/firestore';
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import ServicioImg from '../../img/servicioN.png';
import EducacionImg from '../../img/academiaN.png';
import CoworkingImg from '../../img/coworkingN.png';
import EventoImg from '../../img/eventoN.png';

import { db } from '../../Firebase/Firebase';
import './principal.css';
function PrincipalHome() {
    const [userRole, setUserRole] = useState(null);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');
    const [sectorSeleccionado, setSectorSeleccionado] = useState('');
    const [tipoEspacioSeleccionado, setTipoEspacioSeleccionado] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [sectores, setSectores] = useState([]);
    const [tiposEspacio, setTiposEspacio] = useState([]);
    const [sectoresFiltrados, setSectoresFiltrados] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const lugaresCollection = collection(db, 'lugar');
                const tiposEspacioCollection = collection(db, 'tipoespacio');
                const lugaresSnapshot = await getDocs(lugaresCollection);
                const lugaresData = lugaresSnapshot.docs.map(doc => doc.data()); // Obteniendo solo los datos
                const tiposEspacioSnapshot = await getDocs(tiposEspacioCollection);
                const tiposEspacioData = tiposEspacioSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
                const ciudadesSet = new Set();
                const sectoresMap = new Map();
                lugaresData.forEach(lugar => {
                    const ciudad = lugar.CiudadLugar;
                    const sector = lugar.Sector;
                    if (ciudad) ciudadesSet.add(ciudad);
                    if (ciudad && sector) {
                        if (!sectoresMap.has(ciudad)) {
                            sectoresMap.set(ciudad, new Set());
                        }
                        sectoresMap.get(ciudad).add(sector);
                    }
                });

                setCiudades(Array.from(ciudadesSet));
                setSectores(sectoresMap);
                setTiposEspacio(tiposEspacioData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, []);
    useEffect(() => {
        if (ciudadSeleccionada && sectores.has(ciudadSeleccionada)) {
            setSectoresFiltrados(Array.from(sectores.get(ciudadSeleccionada)));
        } else {
            setSectoresFiltrados([]);
        }
    }, [ciudadSeleccionada, sectores]);

    const registrarBusqueda = async (busqueda) => {
        const auth = getAuth();
        const user = auth.currentUser;
        const nombreUsuario = user?.displayName || "Invitado";
        const [nombre, apellido = ""] = nombreUsuario.split(" ");
        const email = user?.email || "Sin email";
        const searchRecord = {
            ...busqueda,
            usuario: {
                nombre: nombre || "Invitado",
                apellido: apellido || "No especificado",
                email,
            },
            timestamp: new Date().toISOString(),
        };
        try {
            await addDoc(collection(db, "SectoresBuscados"), searchRecord);
            console.log("Búsqueda registrada en Firebase:", searchRecord);
        } catch (error) {
            console.error("Error al registrar la búsqueda:", error);
        }
    };
    const handleSearch = async (e) => {
        e.preventDefault();

        // Validaciones previas
        if (!ciudadSeleccionada || !sectorSeleccionado || !tipoEspacioSeleccionado) {
            console.log('Faltan seleccionar algunos filtros');
            setShowModal(true);
            return;
        }

        // Preparar los datos de la búsqueda
        const busqueda = {
            ciudad: ciudadSeleccionada,
            sector: sectorSeleccionado,
            tipoEspacio: tipoEspacioSeleccionado,
        };

        // Registrar la búsqueda en Firebase
        try {
            await registrarBusqueda(busqueda);
            console.log('Búsqueda registrada exitosamente:', busqueda);
        } catch (error) {
            console.error('Error al registrar la búsqueda:', error);
        }

        try {
            // Referencias a las colecciones
            const lugaresRef = collection(db, 'lugar');
            const tiposEspacioRef = collection(db, 'tipoespacio');
            const espaciosRef = collection(db, 'espacios');

            // **1.** Consulta para obtener el lugar según la ciudad y el sector
            const lugaresConsulta = query(
                lugaresRef,
                where('CiudadLugar', '==', ciudadSeleccionada),
                where('Sector', '==', sectorSeleccionado)
            );
            const lugaresSnapshot = await getDocs(lugaresConsulta);
            if (lugaresSnapshot.empty) {
                console.log('No se encontró lugar para la ciudad y sector seleccionados.');
                setShowModal(true);
                return;
            }
            // Obtener el ID del lugar coincidente
            const lugarId = lugaresSnapshot.docs[0].id;
            console.log('ID del lugar encontrado:', lugarId);

            // **2.** Consulta para obtener el tipo de espacio según el tipo seleccionado
            const tiposEspacioConsulta = query(
                tiposEspacioRef,
                where('TipoEspacio', '==', tipoEspacioSeleccionado)
            );
            const tiposEspacioSnapshot = await getDocs(tiposEspacioConsulta);

            if (tiposEspacioSnapshot.empty) {
                console.log('No se encontró tipo de espacio para la selección realizada.');
                setShowModal(true);
                return;
            }

            // Obtener el ID del tipo de espacio coincidente
            const tipoEspacioId = tiposEspacioSnapshot.docs[0].id;

            // **3.** Consulta para obtener los espacios que tengan coincidencia con el lugarId y tipoEspacioId
            // Obtener todos los espacios y filtrar localmente
            const espaciosSnapshot = await getDocs(espaciosRef);
            const espaciosFiltrados = espaciosSnapshot.docs.filter((doc) => {
                const data = doc.data();

                // Asegurarnos de que los valores no tengan espacios o caracteres extraños
                const lugarIdTrimmed = String(data.IdLugar).trim();
                const tipoEspacioIdTrimmed = String(data.TipoEspacio).trim();
                const lugarIdSeleccionadoTrimmed = String(lugarId).trim();
                const tipoEspacioIdSeleccionadoTrimmed = String(tipoEspacioId).trim();

                // Comparación insensible a mayúsculas y con trim
                return lugarIdTrimmed === lugarIdSeleccionadoTrimmed && tipoEspacioIdTrimmed === tipoEspacioIdSeleccionadoTrimmed;
            });

            if (espaciosFiltrados.length === 0) {
                setShowModal(true);
            } else {
                const espaciosIds = espaciosFiltrados.map((espacio) => espacio.id);
                // Redirigir a la página de resultados con los IDs de los espacios
                navigate('/search', {
                    state: {
                        ciudad: ciudadSeleccionada,
                        sector: sectorSeleccionado,
                        tipoEspacio: tipoEspacioSeleccionado,
                        espaciosIds: espaciosIds,  // Pasar todos los IDs de los espacios
                    },
                });
            }

        } catch (error) {
            console.error('Error al buscar coincidencias:', error);
            setShowModal(true);
        }
    };

    return (
        <div className='hero-section'>
            <div className='hero-content'>
                <div className='hero-info'>
                    <div className='logo-home-cont'>

                    </div>
                    <p className='text-1'>
                        Pon tu espacio en <strong>"LaOfi.work"</strong> como anfitrión o reserva
                        <strong> el espacio de trabajo ideal</strong>, por el tiempo y en el lugar que necesitas.
                    </p>
                    {
                        /* <div className='action-buttons'>
                        <Link to="/mapUsert"><button className='primary-btn'>Tus Espacios</button></Link>
                        <Link to="/#"><button className='primary-btn' >Pon tu espacio</button></Link>
                    </div> */
                    }

                </div>
                {
                    /*
                    <div className='search-box'>
                    <div className='top-buttons'>
                                        <Link to="mapUsert"><button className='btn-reserva'>Reserva</button></Link>
                                        <Link to="/servicios"><button className='btn-servicios'>Servicios</button></Link>
                                    </div>
                
                                    <form onSubmit={handleSearch} className='search-form'>
                                        <br />
                                        <h4>BUSCA LO QUE NECESITES</h4>
                
                                        <select
                                            className='input-select'
                                            value={ciudadSeleccionada}
                                            onChange={(e) => {
                                                setCiudadSeleccionada(e.target.value);
                                                setSectorSeleccionado('');
                                            }}
                                            required
                                        >
                                            <option value='' disabled>Ciudad</option>
                                            {ciudades.map((ciudad, i) => (
                                                <option key={i} value={ciudad}>{ciudad}</option>
                                            ))}
                                        </select>
                
                                        <select
                                            className='input-select'
                                            value={sectorSeleccionado}
                                            onChange={(e) => setSectorSeleccionado(e.target.value)}
                                            disabled={!ciudadSeleccionada}
                                            required
                                        >
                                            <option value=''>Locación</option>
                                            {sectoresFiltrados.map((sector, i) => (
                                                <option key={i} value={sector}>{sector}</option>
                                            ))}
                                        </select>
                
                                        <select
                                            className='input-select'
                                            value={tipoEspacioSeleccionado}
                                            onChange={(e) => setTipoEspacioSeleccionado(e.target.value)}
                                            disabled={!sectorSeleccionado}
                                            required
                                        >
                                            <option value=''>Tipo de Espacio</option>
                                            {tiposEspacio.map((tipo) => (
                                                <option key={tipo.id} value={tipo.TipoEspacio}>{tipo.TipoEspacio}</option>
                                            ))}
                                        </select>
                
                                        <button type="submit" className='green-btn'>Buscar</button>
                                    </form>
                
                                    {showModal && (
                                        <div className='modal-msg'>
                                            <p>No se encontraron coincidencias. Intenta con otros criterios.</p>
                                            <button onClick={() => setShowModal(false)}>Cerrar</button>
                                        </div>
                                        
                        </div>
                                    )}*/
                }

                <div className="coinsdash-grid">
                    <Link to="/coworking">
                        <div className="grid-item">
                            <img src={CoworkingImg} alt="coworking" />
                        </div>
                    </Link>
                    <Link to="/servicios">
                        <div className="grid-item">
                            <img src={ServicioImg} alt="servicios" />
                        </div>
                    </Link>
                    <Link to="https://edu-laofi-academy.odoo.com/" target="_blank">
                        <div className="grid-item">
                            <img src={EducacionImg} alt="educación" />
                        </div>
                    </Link>
                    <Link to="https://laofieventos.odoo.com/" target="_blank">
                        <div className="grid-item">
                            <img src={EventoImg} alt="eventos" />
                        </div>
                    </Link>
                </div>

            </div>
        </div>

    )


}
export default PrincipalHome;